/* eslint-disable */
import { find } from 'lodash';
import { mapActions } from 'vuex';

const externalLinksMixin = {
  data() {
    return {
      links: null,
    };
  },
  methods: {
    ...mapActions('user', ['getExternalLogins']),
    registrationTrack(label) {
      this.$gtm.trackEvent({
        event: 'eventTrackerTrigger',
        category: 'Registration',
        action: 'submit',
        label,
      });
    },
    twitterLinkClick() {
      this.registrationTrack('Twitter');
      console.log('TWITTER LINK CLICKED', this.twitterLink);
      window.location.href = this.twitterLink;
    },
    facebookLinkClick() {
      this.registrationTrack('Facebook');
      console.log('FACEBOOK LINK CLICKED', this.facebookLink);
      window.location.href = this.facebookLink;
    },
    googleLinkClick() {
      this.registrationTrack('Google');
      console.log('GOOGLE LINK CLICKED', this.googleLink);
      window.location.href = this.googleLink;
    },
  },
  computed: {
    twitterLink() {
      const data = find(this.links, l => l.name === 'Twitter');
      return data ? `${process.env.SOCIAL_AUTH_URL}${data.url}` : null;
    },
    facebookLink() {
      const data = find(this.links, l => l.name === 'Facebook');
      return data ? `${process.env.SOCIAL_AUTH_URL}${data.url}` : null;
    },
    googleLink() {
      const data = find(this.links, l => l.name === 'Google');
      return data ? `${process.env.SOCIAL_AUTH_URL}${data.url}` : null;
    },
  },
};


export default externalLinksMixin;



// WEBPACK FOOTER //
// ./src/mixins/externalLinks.js